import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 품목 WIP 프로파일(품목상위그룹>품목>인벤토리>공정>고객별 재공대기/생산/소비 크로스탭) —
// AnalysisController#getItemWipProfileGrid(백엔드는 factoryplan/analysis/item-wip-profile). InoutStatus와
// 동일한 { crosstabHeader, chartHeader, data[].pivotData } 형태이되, 그룹당 행 3개(analysisIndicator =
// FP_PRODUCTION/FP_CONSUMPTION/FP_WAIT, ItemWipProfileService#getItemWipProfiles)가 항상 같이 내려온다.
// old도 customerCdNm/routeCdNm/itemCdNm 자유 텍스트 필터를 실제로 params에 실어 보내고
// (ItemWipProfileQueryRepository가 이 3개를 contains 조건으로 소비) 그리드/차트 둘 다 씀 — postParams만.
const getItemWipProfiles = (params) => fpApiUtil.postParams(`${ANALYSIS}/item-wip-profile`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(itemParentGrpCd/itemCd/inventoryCd/routeCd/
// customerCd)으로 드릴다운. changes(FilterParameter: 컬럼 필터+analysisIndicators)는 1차 미이관이라
// 항상 빈 객체로 보낸다(InoutStatus와 동일 결정, §A-6e).
const getItemWipProfileChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/item-wip-profile`, { params, changes });

const fpItemWipProfileService = { getItemWipProfiles, getItemWipProfileChart };
export default fpItemWipProfileService;
